// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3gVSK","def":"styles_def__1HA9H","faded":"styles_faded__XVu9Q"};